export default __webpack_public_path__ + "static/media/frame2.88ad417c.png";